module.exports = __webpack_public_path__ + "img/game04.81e0b051.png";